import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide09Metrics({
  index
}: SlideProps) {
  return <InteriorSlide surface data-id="element-192" data-mp="2phe8w9xi9wmo">
      <SlideHeader eyebrow="6-Month Proposal" data-id="element-193" data-mp="2pgmpdxh6npcr">
        6-month model: strong first campaign wave
      </SlideHeader>

      <div className="flex-1 flex flex-col max-w-5xl mx-auto w-full" data-id="element-194" data-mp="2khigz9231vnh">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-10" data-id="element-195" data-mp="2gjceid8a228d">
          The 6-month proposal gives GSK a strong first campaign wave and enough
          monthly activity to measure performance, gather HCP behavioral
          insights, and optimize the communication approach for the established
          brands.
        </motion.p>

        <div className="flex flex-col gap-6" data-id="element-196" data-mp="3o4a5it4hqlwr">
          {/* Highlighted Campaign Cost */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="bg-white rounded-3xl shadow-lg border-2 border-[var(--brand)] p-8 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden" data-id="element-197" data-mp="3o1xg5uwel99o">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[var(--brand)]/5 rounded-bl-full -mr-32 -mt-32" data-id="element-198" data-mp="3s5lmka9atytc" />
            <div data-id="element-199" data-mp="xhj5b0pkzzt">
              <h3 className="text-2xl font-bold text-[var(--fg)] mb-2" data-id="element-200" data-mp="op54zej45kv8">
                Monthly Campaign Adaptation
              </h3>
              <p className="text-[var(--muted)] text-lg" data-id="element-201" data-mp="tgwwbra3fumf">
                High-quality interactive campaigns at scale.
              </p>
            </div>
            <div className="text-center md:text-right" data-id="element-202" data-mp="139hm523p3lo1">
              <div className="text-5xl font-extrabold text-[var(--brand)]" data-id="element-203" data-mp="ye292cdihtso">
                €600
              </div>
              <div className="text-sm font-bold text-[var(--muted)] uppercase tracking-wider mt-1" data-id="element-204" data-mp="u9cfiu6bsrax">
                per campaign
              </div>
              <div className="text-sm font-medium text-[var(--fg)] mt-2" data-id="element-205" data-mp="kdj5pijzrbwu">
                Total for 6 months: €3,600
              </div>
            </div>
          </motion.div>

          {/* Initial Master Costs */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-206" data-mp="ao7zc3oholcn">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.6
          }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-6 flex flex-col" data-id="element-207" data-mp="6lkzpglktw4w">
              <div className="text-xs font-bold text-[var(--muted)] uppercase tracking-wider mb-2" data-id="element-208" data-mp="2d926onduziq0">
                Initial Cost
              </div>
              <h4 className="text-xl font-bold text-[var(--fg)] mb-4" data-id="element-209" data-mp="2i6txfe2roysm">
                Master Teaser
              </h4>
              <div className="text-3xl font-bold text-[var(--fg)] mb-4" data-id="element-210" data-mp="1pk9acptbr8uv">
                €2,500
              </div>
              <div className="mt-auto pt-4 border-t border-black/5" data-id="element-211" data-mp="1uiu90ksxhkh7">
                <div className="text-sm text-[var(--muted)]" data-id="element-212" data-mp="1ugzmx35x7mbj">
                  Amortized over 6 months:
                </div>
                <div className="text-lg font-bold text-[var(--brand)]" data-id="element-213" data-mp="23c7aib525uew">
                  €416.67{' '}
                  <span className="text-sm font-normal text-[var(--muted)]" data-id="element-214" data-mp="16ub2a9pj1fr8">
                    / campaign
                  </span>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6,
            duration: 0.6
          }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-6 flex flex-col" data-id="element-215" data-mp="rq8arbbvaqgq">
              <div className="text-xs font-bold text-[var(--muted)] uppercase tracking-wider mb-2" data-id="element-216" data-mp="1afy37rs5r05h">
                Initial Cost
              </div>
              <h4 className="text-xl font-bold text-[var(--fg)] mb-4" data-id="element-217" data-mp="1kff6k2jxt1ya">
                Master Trailer / Microsite
              </h4>
              <div className="text-3xl font-bold text-[var(--fg)] mb-4" data-id="element-218" data-mp="1fg2mfpkga8ze">
                €3,500
              </div>
              <div className="mt-auto pt-4 border-t border-black/5" data-id="element-219" data-mp="3m7l7oyn8mgy8">
                <div className="text-sm text-[var(--muted)]" data-id="element-220" data-mp="3h88meic0lhxr">
                  Amortized over 12 months:
                </div>
                <div className="text-lg font-bold text-[var(--brand)]" data-id="element-221" data-mp="1wqzh11yx6shh">
                  €291.67{' '}
                  <span className="text-sm font-normal text-[var(--muted)]" data-id="element-222" data-mp="21ng6bzhuvcw5">
                    / campaign
                  </span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Total */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.7,
          duration: 0.6
        }} className="bg-[var(--brand)] rounded-2xl shadow-md p-6 flex items-center justify-between text-white" data-id="element-223" data-mp="1rwliiqoyo58l">
            <div className="font-bold text-xl uppercase tracking-wider" data-id="element-224" data-mp="2yf0fo1awyql1">
              Total 6-month proposal
            </div>
            <div className="font-bold text-3xl" data-id="element-225" data-mp="33ed0yhm4zpli">€9,600</div>
          </motion.div>
        </div>
      </div>
    </InteriorSlide>;
}